import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_CUSTOMERS_REQUEST,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  CREATE_CUSTOMER_REQUEST,
  createCustomerSuccess,
  createCustomerFailure,
} from '../actions/customerActions';

// Worker Saga: Fetch Customers
function* fetchCustomers() {
  try {
    const response = yield call(axios.get, '/sampleCustomerData.json');
    yield put(fetchCustomersSuccess(response.data));
  } catch (error) {
    yield put(fetchCustomersFailure(error.message));
  }
}

// Worker Saga: Create Customer
function* createCustomer(action) {
  try {
    const response = yield call(axios.post, '/createCustomer', action.payload);
    yield put(createCustomerSuccess(response.data));
  } catch (error) {
    yield put(createCustomerFailure(error.message));
  }
}

// Watcher Saga: Watch for actions
function* customerSaga() {
  yield takeLatest(FETCH_CUSTOMERS_REQUEST, fetchCustomers);
  yield takeLatest(CREATE_CUSTOMER_REQUEST, createCustomer);
}

export default customerSaga;
